export default __webpack_public_path__ + "static/holding-car-home-screen-desktop-ec6014bca8664f64986e2b514047f72b.png";